import type { Hole } from "../../shared/types.js";

/**
 * Which hole to open a round's scorecard on.
 *
 * The scorecard is a tab, and a tab switch unmounts it — so the hole you were on is
 * local state that dies every time you glance at the standings. Remembering it in
 * localStorage is what stops a player on 16 being dropped back onto the 1st tee for
 * looking (see `getLastHole`); this is the pure half of that, kept DOM-free so it can
 * be tested.
 *
 * A hole *number* is what gets remembered, never the index it sat at. The two only
 * agree on a front nine: the back nine's third hole is number 12, and a round the
 * organiser switches from eighteen holes to a back nine underneath a player would
 * otherwise resume somewhere they have never been. Anything that no longer names a
 * hole in play — a missing entry, a hole dropped out of the round — starts at the
 * first, which is where an unremembered round starts anyway.
 */
export function resumeHoleIndex(holes: Hole[], savedHole: number | null): number {
  if (savedHole == null) return 0;
  const i = holes.findIndex((h) => h.number === savedHole);
  return i >= 0 ? i : 0;
}
